import Box from '@mui/material/Box';

import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { NoData } from '../../../components/Illustrations/NoData';
import { DataGrid } from '../../../components/DataGrid';
import { Loading } from '../../../components/Loading';

import { useInitialGridState } from '../hooks/useInitialGridState.hook';
import { useFindAllDocumentTemplatesQuery } from '../hooks/useFindAllDocumentTemplatesQuery.hook';

import { getColumns } from './get-columns';

export const DocumentTemplatesList = () => {
  const { data, isSuccess } = useFindAllDocumentTemplatesQuery();

  const { documentTypes, genericStatuses } = useReferencesContext();

  const { initialGridState } = useInitialGridState();

  if (isSuccess) {
    const { findAllDocumentTemplates: documentTemplates } = data;

    return !documentTemplates.length ? (
      <NoData />
    ) : (
      <Box sx={{ flexGrow: 1, width: '100%', pt: 2 }}>
        <DataGrid
          columns={getColumns(documentTypes, genericStatuses)}
          initialState={initialGridState}
          rows={documentTemplates}
        />
      </Box>
    );
  }

  return <Loading />;
};
